import FetchError from "../services/api/FetchError";

export const initFetchState = () => ({
  status: "WAITING_FOR_FETCH",
  data: null,
  error: null,
});

export const createFetchFunc = (item) => (state, payload) => {
  if (payload === "FETCHING") {
    state[item].status = state[item].data ? "UPDATING" : "FETCHING";
    state[item].error = null;
  } else if (payload instanceof FetchError) {
    state[item].status = "ERROR";
    state[item].error = payload;
  } else {
    state[item].status = "READY";
    state[item].error = null;
    state[item].data = payload;
  }
};
